import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		"& > *": {
			margin: theme.spacing(1),
		},
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			marginLeft: 0,
			justifyContent: "flex-start",
			"& > *": {
				margin: theme.spacing(0.5, 0.75, 0, 0),
			},
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
